export class SearchCondition {
  submitted_at_from: string = ""
  submitted_at_to: string = ""
  result_published_at_from: string = ""
  result_published_at_to: string = ""
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  subject_code: string = null
  is_group_scored_user_name: boolean = false
  is_group_student: boolean = false
}

export class SaitenCount {
  sheet_code: string
  subject_code: string
  subject_name: string
  report_no: number
  saiten_count: number
  scored_user_name: string
  student_name: string

  constructor(x: any){
    this.sheet_code = x.sheet_code;
    this.subject_code = x.subject_code;
    this.subject_name = x.subject_name;
    this.report_no = x.report_no;
    this.saiten_count = x.saiten_count;
    this.scored_user_name = x.scored_user_name;
    this.student_name = x.name;
  }
}